function isPasswordValid(password) {
    const hasMinimalLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    return hasMinimalLength && hasUppercase && hasLowercase && hasNumber;
}

function generateRandomPassword() {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const allChars = upper + lower + numbers;

    let password = '';
    for (let i = 0; i < 12; i++) {
        password += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }
    return password;
}

export default {
    isPasswordValid,
    generateRandomPassword
}
